  <button *ngIf="showButton()" mat-raised-button color="{{uiArtefakt.Color.toLowerCase()}}"
        [disabled]="isDisabled || loading
        || (uiArtefakt.Command === 'Beantragen' && votumErgebnis === 'Ablehnen')"
        (click)="onCommand()" class="lv-primary-button">
  <div *ngIf="loading" class="lv-button-spinner">
    <mat-progress-spinner class="lv-progress-spinner-white" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
  </div>
  <div [ngClass]="{'lv-hide-label': loading}">
    {{uiArtefakt.Text}}
  </div>
</button>


